import { useEffect, useMemo, useState } from 'react';

const LESSON_FOOTER_ATTR = 'lesson-footer-portal';

// This hook gives access to the portal that frames can use to place components in the
// footer of the lesson player
export function useFooterContent() {
    const [container, setContainer] = useState<HTMLDivElement | null>(null);

    useEffect(() => {
        let animationFrameId: number | null = null;
        let isCancelled = false;

        const findContainer = () => {
            if (isCancelled) return;
            const element = document.querySelector(`[data-${LESSON_FOOTER_ATTR}]`) as HTMLDivElement | null;
            if (element) {
                setContainer(element);
                return;
            }
            animationFrameId = window.requestAnimationFrame(findContainer);
        };

        findContainer();

        return () => {
            isCancelled = true;
            if (animationFrameId !== null) {
                window.cancelAnimationFrame(animationFrameId);
            }
            setContainer(null);
        };
    }, []);

    return useMemo(() => container, [container]);
}
